module.exports = __webpack_public_path__ + "static/media/company_2.png";